import React, { MutableRefObject } from 'react';

import {
  FieldEventType,
  PersonalisationProductOption,
  ProductOption,
  SelectionProductOption,
} from 'src/types';
import { InputOnChangeArgs } from '../../components/Input';
import { InputContainer } from '../../containers/InputContainer';
import { MultipleOptionSelectionContainer } from '../../containers/MultipleOptionSelectionContainer';
import { SelectionSingleOrBinaryContainer } from '../../containers/SelectionSingleOrBinaryContainer';
import { PersonalisationOptionsListItem } from '../PersonalisationOptionsListItem';
import * as styles from '../../styles/Personalisation.styles';

interface Props {
  displayValidation: boolean | undefined;
  isExpanded?: boolean;
  listItemRef: MutableRefObject<HTMLLIElement | null> | null;
  option: ProductOption;
  wrapperRef: MutableRefObject<HTMLUListElement | null>;
  onChange?: (selection: InputOnChangeArgs) => void;
  onFocus: (option?: ProductOption, fieldType?: FieldEventType) => void;
  toggleExpanded: () => void;
}

export const PersonalisationOption = ({
  displayValidation,
  listItemRef,
  isExpanded,
  option,
  wrapperRef,
  onChange,
  onFocus,
  toggleExpanded,
}: Props) => {
  if (option.type === 'selection') {
    return option.values!.length < 3 ? (
      <PersonalisationOptionsListItem
        listItemRef={listItemRef}
        key={option.id}
        cssProp={styles.personalisationOption}
        onFocus={onFocus}
      >
        <SelectionSingleOrBinaryContainer
          displayValidation={displayValidation}
          isExpanded={isExpanded}
          toggleExpanded={toggleExpanded}
          {...(option as SelectionProductOption)}
        />
      </PersonalisationOptionsListItem>
    ) : (
      <PersonalisationOptionsListItem
        listItemRef={listItemRef}
        key={option.id}
        cssProp={styles.personalisationOption}
        onFocus={() => onFocus(option, '3 and more values selection')}
      >
        <MultipleOptionSelectionContainer
          {...(option as SelectionProductOption)}
          displayValidation={displayValidation}
          forwardedRef={wrapperRef}
        />
      </PersonalisationOptionsListItem>
    );
  }

  return (
    <PersonalisationOptionsListItem
      listItemRef={listItemRef}
      key={option.id}
      cssProp={styles.personalisationOption}
      onFocus={() => onFocus(option, 'input field')}
    >
      <InputContainer
        {...(option as PersonalisationProductOption)}
        required={option.required}
        displayValidation={displayValidation}
        onChange={onChange!}
      />
    </PersonalisationOptionsListItem>
  );
};
